import { render, staticRenderFns } from "./PavilionButton.vue?vue&type=template&id=20061fec&scoped=true"
import script from "./PavilionButton.vue?vue&type=script&lang=js"
export * from "./PavilionButton.vue?vue&type=script&lang=js"
import style0 from "./PavilionButton.vue?vue&type=style&index=0&id=20061fec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20061fec",
  null
  
)

export default component.exports